import styled from "styled-components";

const ease = "cubic-bezier(0.2, 0.7, 0.2, 1)";

export const NavMenuWrapper = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  padding-bottom: 36px;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding-bottom: 20px;
  }
`;

export const LogoContainer = styled.a`
  display: flex;
  align-items: center;
  width: 16%;
  transition: opacity 0.25s ease;
  &:hover {
    opacity: 0.85;
  }
  @media (max-width: 768px) {
    width: auto;
  }
`;

export const Logo = styled.img`
  height: 80px;
  @media (max-width: 768px) {
    height: 40px;
  }
`;

export const NavMenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Menu = styled.div`
  padding: 5px;
  width: 81%;
  min-width: 700px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    display: none;
  }
`;

// Underline drawn from the left on hover.
export const MenuItem = styled.a`
  padding: 4px 0;
  margin: 0 18px;
  color: #fafbff;
  font-size: 1.08rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-decoration: none;
  background: linear-gradient(#02c5ff, #02c5ff) no-repeat left bottom / 0 2px;
  transition: background-size 0.35s ${ease}, color 0.25s ease;
  &:hover,
  &:focus-visible {
    color: #fff;
    background-size: 100% 2px;
    outline: none;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 10px;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid rgba(250, 251, 255, 0.22);
    border-radius: 50%;
    transition: transform 0.3s ${ease}, background-color 0.3s ease, border-color 0.3s ease;
  }
  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
  a:hover,
  a:focus-visible {
    transform: translateY(-3px);
    background: rgba(2, 197, 255, 0.18);
    border-color: #02c5ff;
    outline: none;
  }
  @media (prefers-reduced-motion: reduce) {
    a {
      transition: none;
    }
  }
`;
